import { isDomContentLoaded } from '../../modules/get_perfomance'
import { getApiUrlString, setUrlMap } from '../../modules/get_apiUrlString'
import { getCode }  from '../../modules/get_code'

export default () => {

  const init = () => {
    setUrlMap(window.pist6);
    const worker = new Worker('/assets/js/data/worker/api_thread.js');
    worker.postMessage({
      url: getApiUrlString('tournament', ''),
      cb: (cb).toString()
    })
    worker.addEventListener('message', evt => {
      if (isDomContentLoaded()) {
        buildRace(evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildRace(evt.data);
        })
      }
    })
  }

  // worker側で実行される処理
  // 取得したデータの再構築
  const cb = (data) => {
    console.log(data.api.hold_daily_schedule_list)
    const groupingSchedules = data.api.hold_daily_schedule_list.reduce((result, schedule, idx) => {
      const key = `${schedule.promoter_year}_${schedule.season}_${schedule.round_code}`;
      if (!result[key]) {
        result[key] = {
          idx: idx,
          schedules: []
        };
      }
      result[key].schedules.push(schedule);
      return result;
    }, {});
    const currentRoundSchedules = Object.values(groupingSchedules)
      .sort((a, b) => a.idx - b.idx)
      .map(group => group.schedules)
      .shift();
    console.log('currentRoundSchedules', currentRoundSchedules);
    const weekMap = [
      '日', '月', '火', '水', '木', '金', '土'
    ]
    const displaySchedule = {
      date_range: [
        `<span class="_start">${currentRoundSchedules[0].event_date.replace(/-/g, '.')}</span>`,
        `<span class="_week">(${weekMap[(new Date(currentRoundSchedules[0].event_date)).getDay()]}曜日)</span>`,
        `<span class="_separator">ー</span>`,
        `<span class="_end">${currentRoundSchedules[currentRoundSchedules.length - 1].event_date.replace(/-/g, '.')}</span>`,
        `<span class="_week">(${weekMap[(new Date(currentRoundSchedules[currentRoundSchedules.length - 1].event_date)).getDay()]}曜日)</span>`,
      ].join(''),
      season: currentRoundSchedules[0].season,
      round_code: currentRoundSchedules[0].round_code
    }
    // .slice(0, 6)
    postMessage(displaySchedule);
  }

  // レース一覧DOM生成
  const buildRace = (data) => {
    console.log('current_round_info data:', data);
    const race = document.getElementById('infoRace');
    const dateElement = race.querySelector('.hm-info-race__date-txt');
    dateElement.innerHTML = data.date_range;
    const nameElement = race.querySelector('.hm-info-race__name-txt');
    nameElement.textContent = `${getCode('seasonText', data.season).ja}${getCode('round', data.round_code).name}`;

  }

  init();
}
